import type { CommentsAction } from "@/components/Comment/reducer/comment-reducer.types"
import {
  appendRepliesToComment,
  insertReplyInTree,
} from "@/components/Comment/utilities/comment-tree"
import type { CommentModel } from "@/services/api/comment/models/comment.model.types"

export type PaginationState = {
  readonly hasNextPage: boolean
  readonly endCursor: string | null
}

export type CommentsState = {
  readonly comments: ReadonlyArray<CommentModel>
  readonly totalComments: number
  readonly pagination: PaginationState
  readonly isModalOpen: boolean
}

export function commentsReducer(
  state: CommentsState,
  action: CommentsAction,
): CommentsState {
  switch (action.type) {
    case "ADD_COMMENT":
      return {
        ...state,
        comments: [action.comment, ...state.comments],
        totalComments: state.totalComments + 1,
      }

    case "ADD_REPLY": {
      // TODO: Remove ancestorId fallback when backend supports flatten on createComment
      const targetParentId = action.ancestorId ?? action.reply.parentId

      if (!targetParentId) {
        return state
      }

      return {
        ...state,
        comments: state.comments.map((c) =>
          insertReplyInTree(c, targetParentId, action.reply),
        ),
        totalComments: state.totalComments + 1,
      }
    }

    case "APPEND_COMMENTS":
      return {
        ...state,
        comments: [...state.comments, ...action.paginated.comments],
        pagination: {
          endCursor: action.paginated.endCursor,
          hasNextPage: action.paginated.hasNextPage,
        },
      }

    case "APPEND_REPLIES":
      return {
        ...state,
        comments: state.comments.map((c) =>
          appendRepliesToComment(c, action.commentId, action.paginated),
        ),
      }

    case "OPEN_MODAL":
      return { ...state, isModalOpen: true }

    case "CLOSE_MODAL":
      return { ...state, isModalOpen: false }
  }
}
